import { useContext } from 'react';
import { styled } from "@mui/material";
import Button from "../../../../customs/Button";
import { NotificationContext } from '../../../../providers/notification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiCall from '../../../../utils/apiCall';

interface ComponentProps{
    handleClose: () => void;
    id: number;
    routeName: string;
}

interface Payload {
    RouteName: string;
}

const DeleteRouteContent = ({id, routeName, handleClose}: ComponentProps) => {
    const { showNotification } = useContext(NotificationContext);
    const queryClient = useQueryClient();

    const deleteRoute = async (data: Payload) => {
        return await(apiCall().delete(`/Routes/${id}`));
    };

    const deleteRouteMutation = useMutation(['delete-route'], deleteRoute, {retry: 0});

    const deleteRouteHandler = async () => {
        const payload: Payload = {
            RouteName: routeName
        };

        try {
            await deleteRouteMutation.mutateAsync(payload, {
                onSuccess: () => {
                    showNotification({
                        type: 'success',
                        message: 'Route Page Successfully deleted'
                    });
                    queryClient.refetchQueries(['get-all-routes-Page']);
                }
            })
        } catch(error: any) {
            showNotification({
                type: 'error',
                message: error?.response?.data?.Message || error?.message,
            })
        }
    };

    const handleDelete = () => deleteRouteHandler();

    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>Examination/NYSC Route Page</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton text='Cancel' onClick={handleClose}/>
                    <StyledButton 
                        type="submit" 
                        text={deleteRouteMutation.isLoading ? 'Deleting' : 'Yes, Delete'} 
                        disabled={deleteRouteMutation.isLoading}
                        bg="#DD5151;" 
                        onClick={handleDelete}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteRouteContent;

const StyledContainer = styled('div')`
    margin-inline-start: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`